import qs from 'qs';
import axios from '@utils/axios';
import { Response } from '@shared/model/type/response.type';

export interface SendSysMsgReq {
    userIds: string;
    msgCN: string;
    msgEN: string;
    kind: number;
}

export interface SysNoticeKind {
    id?: number;
    name?: string;
}

export interface PublicImage {
    id: number;
    name: string;
}

export interface PublicSoftware {
    id: number;
    name: string;
}

interface updatePayload {
    docId: number;
    isSend?: number;
    level?: number;
    showTime?: string;
    state: number;
    title: string;
    url?: string;
}

export function createBohriumUpdate(data: {
    isSend: number;
    level: number;
    showTime: string;
    state: number;
    title: string;
    url: string;
}) {
    return axios.post(`/v1/bohrium/doc/add`, data) as Promise<Response>;
}

export function getBohriumUpdatesList(data: { state?: number; page: number; pageSize: number; title?: string }) {
    return axios.get(`/v1/bohrium/doc/list`, {
        params: {
            ...data,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { indices: false });
        },
    }) as Promise<Response>;
}

export function getBohriumDetail(id: number) {
    return axios.get(`/v1/bohrium/doc/${id}`) as Promise<Response>;
}

export function updateBohriumDetail(data: updatePayload) {
    return axios.post('/v1/bohrium/doc/update', data) as Promise<Response>;
}

export function sendSysMsg(data: SendSysMsgReq) {
    return axios.post('/v1/bohrium/notice/sends', data) as Promise<Response>;
}

export function getSysMsgKinds() {
    return axios.get('/v1/bohrium/notice/kinds') as Promise<Response>;
}

export function getPubImageList(data: { state?: number; page: number; pageSize: number; title?: string }) {
    return axios.get(`/v1/bohrium/software/version/list`, {
        params: {
            ...data,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { indices: false });
        },
    }) as Promise<Response>;
}

export function getPubImageVersionDetail(imageVersionId: number) {
    return axios.get(`/v1/bohrium/software/version/${imageVersionId}`) as Promise<Response>;
}

export function getPubSoftwareList() {
    return axios.get(`/v1/bohrium/software/list`) as Promise<Response>;
}

export function updateImageVersion(
    data: {
        imageId: number;
        lbgId: number;
        sort: number;
        software: string;
        version: string;
    },
    imageVersionId: number
) {
    return axios.post(`/v1/bohrium/software/version/${imageVersionId}/update`, data) as Promise<Response>;
}

export function createImageVersion(data: {
    imageId: number;
    lbgId: number;
    sort: number;
    software: string;
    version: string;
}) {
    return axios.post(`/v1/bohrium/software/version/add`, data) as Promise<Response>;
}

export function getCourseList(data: { page: number; pageSize: number; type?: string; orderBy?: string }) {
    data.type = 'admin';
    data.orderBy = 'publish';
    return axios.get(`/v1/bohrium/course/list`, {
        params: {
            ...data,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { indices: false });
        },
    }) as Promise<Response>;
}

export function getCourseManagerList(id: string) {
    return axios.get(`/v1/bohrium/course/${id}/manager/list`) as Promise<Response>;
}

interface CourseManager {
    courseId: string;
    emailOrPhone: string;
    userId: number;
    roleType: number;
}
export function addCourseManager(data: CourseManager[]) {
    return axios.post(`/v1/bohrium/course/manager/add`, { item: data }) as Promise<Response>;
}

export function delCourseManager(data: CourseManager[]) {
    return axios.post(`/v1/bohrium/course/manager/del`, { item: data }) as Promise<Response>;
}
